import { render, staticRenderFns } from "./ConsultationsSlices.vue?vue&type=template&id=9dab7f4c&scoped=true"
import script from "./ConsultationsSlices.vue?vue&type=script&lang=js"
export * from "./ConsultationsSlices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dab7f4c",
  null
  
)

export default component.exports